import isApiError from "@insite/client-framework/Common/isApiError";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    Handler,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { addWishListLines } from "@insite/client-framework/Services/WishListService";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { AddLineToWishList, chain } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@thos/Store/CustomApplicationState";
import setAllSelectedToAddToList from "@thos/Store/Data/OrderHistory/Handlers/SetAllSelectedToAddToList";
import setCopyNotesSelected from "@thos/Store/Data/OrderHistory/Handlers/SetCopyNotesSelected";

export interface AddToWishListParameter {
    productInfos: Omit<ProductInfo, "productDetailPath">[];
    selectedWishList?: WishListModel;
    newListName?: string;
    onSuccess?: (wishList: WishListModel) => void;
    onError?: (errorMessage: string) => void;
}

interface Props {
    result: {
        wishList?: WishListModel;
        errorMessage?: string;
    };
}

type HandlerType = Handler<AddToWishListParameter, Props>;
export const AddLineWithNotesToWishList: HandlerType = async props => {
    const selectedLineItemsByUser = (props.getState() as CustomApplicationState).ThosState.OrderHistory;

    if (selectedLineItemsByUser && selectedLineItemsByUser?.reOrderListArray && selectedLineItemsByUser?.reOrderListArray.length !== 0) {
        const state = props.getState();
        const order = getOrderState(state, state.pages.orderDetails.orderNumber);

        if (!props.result.wishList) {
            return;
        }

        if (!order.value) {
            throw new Error("There was no order available");
        }

        try {
            const lines: {
                productId: string,
                qtyOrdered: number,
                unitOfMeasure: string,
                notes: string
            }[] = []

            selectedLineItemsByUser.reOrderListArray.forEach((lineItemId: string) => {
                const orderLine = order.value.orderLines?.find(x => x.id === lineItemId);
                if (orderLine && orderLine !== null) {
                    lines.push({
                        productId: orderLine.productId,
                        qtyOrdered: orderLine.qtyOrdered,
                        unitOfMeasure: orderLine.unitOfMeasure,
                        notes: selectedLineItemsByUser.isCopyNotesSelected ? orderLine.notes : ""
                    })
                }
            });

            await addWishListLines({ wishList: props.result.wishList, lines });

            props.dispatch(
                setCopyNotesSelected({ isCopyNotesSelected: false })
            );
            props.dispatch(
                setAllSelectedToAddToList({ allChecked: false })
            )
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.result.errorMessage = error.errorJson.message;
                return;
            }
            if (error?.status === 404) {
                props.result.errorMessage = error.errorMessage;
                return;
            }
            throw error;
        }
    }
    else {
        if (!props.result.wishList) {
            return;
        }

        try {
            const lines = props.parameter.productInfos.map(productInfo => ({
                productId: productInfo.productId,
                qtyOrdered: productInfo.qtyOrdered,
                unitOfMeasure: productInfo.unitOfMeasure,
            }));
            await addWishListLines({ wishList: props.result.wishList, lines });
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.result.errorMessage = error.errorJson.message;
                return;
            }
            if (error?.status === 404) {
                props.result.errorMessage = error.errorMessage;
                return;
            }
            throw error;
        }
    }
};

replaceInChain(chain, AddLineToWishList, AddLineWithNotesToWishList);